<!-- 
    <cropper @childFun="childFun2"   :data="cropper_data"  ></cropper>    

    import cropper from '../../child_vue/vue_cropper.vue';

    components: {cropper},
    data(){ return {
                    
        cropper_data:{
            vCropper:'5',        //插件分组(同一页面不能使用两个vue-cropper,通过v-if进行判断,因多级路由使父路由和子路由也存在冲突所以用vuex鉴别)
            btn_name: '上传图片',
            outputType: 'jpeg',  //生成图片格式
            type:'1',            //图片分组
            enlarge:"1",         //倍数
            autoCropWidth:"200",
            autoCropHeight:"200"
        },  

        child_val: null,  //child 反馈
    }}


    methods:{
        childFun2 (data){
            let that = this;
            that.child_val = data.pic_url;          
            
        }
    }

    that.$upload(         上传图片，没上传地址
        that.child_val
    ).then(res => { })

    如果按钮为图片则
    <cropper    @childFun="childFun2"  :head_type="user"  :data="cropper_data"  ></cropper> 
    

-->

<template>
    <div>
        <!-- 头像 -->
        <div v-if="head_type == 'user'">
            <label @click="openFun" class="btn" for="uploads">
                <img  v-if="head_pic"   :src="head_pic"  alt="">
                <img  v-if="!head_pic"  src="../../../public/images/head_01.png"   alt="">
                <div class='sctx' >上传头像</div>
            </label>
        </div>
        <!-- 按钮 -->
        <div v-if="!head_type">
            <label  @click="openFun" class="btn mR8" for="uploads">
                <Button type="info" icon="md-cloud-upload" >{{ data.btn_name }}</Button>  
            </label>
            
            <span type="text"  class="b_txt cRed" v-if="data">*建议尺寸 : {{data.autoCropWidth*data.enlarge}}x{{data.autoCropHeight*data.enlarge}} </span>
        </div>
        
        
       
        <Modal  width='420'
            title="图片裁剪"
            v-model="open"
            @on-ok="finish"
            @on-cancel="closeTan"   

            class-name="vertical-center-modal"
        >
            <div  class="cropper-component " v-if='is_change_vCropper == data.vCropper '>     <!-- 必须关闭一个，否则互相影响 -->
                <div class="info-item">
                    <div class="btn-box">
                        <input type="button" class="operation-btn" value="+" title="放大" @click="changeScale(0.1)">
                        <input type="button" class="operation-btn" value="-" title="缩小" @click="changeScale(-0.1)">
                        <input type="button" class="operation-btn" value="↺" title="左旋转" @click="rotateLeft">
                        <input type="button" class="operation-btn" value="↻" title="右旋转" @click="rotateRight">
                        <input type="button" class="operation-btn" value="↓" title="下载" @click="down('blob')">
                        
                    </div>
                    <div class="operation-box">
                        <div class="cropper" v-if="open" >
                            <vueCropper
                                
                                ref="cropper1"
                                
                                :img="option.img"
                                :outputSize="option.size"
                                
                                :info="option.info"
                                :full="option.full"
                                :canMove="option.canMove"
                                :canMoveBox="option.canMoveBox"
                                :original="option.original"
                                :autoCrop="option.autoCrop"
                                :fixedBox="option.fixedBox"
                                :centerBox="option.centerBox"
                                :infoTrue="option.infoTrue"
                                :mode="option.mode"
                                :maxImgSize="option.maxImgSize"

                                :outputType="data.outputType"
                                :enlarge="data.enlarge"
                                :autoCropWidth="data.autoCropWidth"
                                :autoCropHeight="data.autoCropHeight"

                                @realTime="realTime"
                                @imgLoad="imgLoad"
                            ></vueCropper>
                        </div>
                    </div>
                    <!-- 底部按钮 -->
                    <div class='bot_btn'>
                        <!-- 取消操作 -->
                        <!-- <div class="bb_01" @click="closeTan">取消操作</div> -->
                        <!-- 选择图片 -->
                        <div class="bb_02">
                            <label class="btn" for="uploads">选择图片</label>
                            <input type="file" id="uploads" :value="imgFile" 
                                style="position:absolute; clip:rect(0 0 0 0);width: 1px;" 
                                accept="image/png, image/jpeg, image/gif, image/jpg"
                                @change="uploadImg($event, 1)">
                        </div>
                        
                        
                    </div>
                </div>
            </div>

        </Modal>
    </div>
    
</template>
<script >
    import $ from 'jquery'
    import { mapState,mapMutations,mapGetters } from 'vuex';
    export default {
        name: "cropper",
        data(){      
            return{
               
                option: {
                    autoCrop: true, // 是否默认生成截图框    
                    img: '', // 裁剪图片的地址
                    info: true, // 裁剪框的大小信息
                    outputSize: 1, // 剪切后的图片质量（0.1-1）
                    full: false, // 输出原图比例截图 props名full    为true 时生成图片会变大很多
                    //outputType: 'jpeg', // 裁剪生成额图片的格式 //png 不兼容 ie11, 上传 jpg 返回的图片在vue ie下无法解读
                    canMove: true,  // 能否拖动图片
                    original: false,  // 上传图片是否显示原始宽高
                    canMoveBox: false,  // 能否拖动截图框
                    maxImgSize:2000,
                    infoTrue: true,
                    centerBox: false,  //框在图中
                    fixedBox: true, // 截图框固定大小
                    mode: 'contain'
                }, 
                //剪切图片上传
                crap: false,
                previews: {},
                fileName:'',  // 本机文件地址
                downImg: '#',
                imgFile:'',
                uploadImgRelaPath:'', // 上传后的图片的地址（不带服务器域名）
                open: false,

                head_pic: null,           //按钮为图片时的图片

                pic_np: {}
            }
        },
        watch:{
           head_bool(val){
               if(!val){
                   let that = this;
                   that.head_pic = that.$store.state.image;
               }
           }
        },
        
        props: ['data','head_type','head_bool'], 
              //是否打开，弹窗编号，截图校于截图框倍数，截框图宽，截图框高
        computed: {
            // is_change_layout(){
            //    return this.$store.getters.is_change_layout
            // },
            is_change_vCropper(){
               return this.$store.getters.is_change_vCropper
            },
        },
        methods: {
           
            openFun(){
                let that = this;
                that.open = true;
                that.option.img = '';
                that.$store.commit('change_vCropper',that.data.vCropper);

                
                $(document).ready(function(){
                    if(that.data.autoCropWidth > that.data.autoCropHeight){
                        $(".cropper").css({
                            "width":  that.data.autoCropWidth + "px"
                        });
                    }else{
                        $(".cropper").css({
                            "height":  that.data.autoCropHeight + "px"
                        });
                    }  
                });
            },
            
            closeTan(){
                var that = this;
                // 关闭截图框
                that.open = false;
            },
            // 放大/缩小
            changeScale(num) { 
                num = num || 1; 
                this.$refs.cropper1.changeScale(num); 
            }, 
            // 坐旋转
            rotateLeft() { 
                this.$refs.cropper1.rotateLeft(); 
            }, 
            // 右旋转
            rotateRight() { 
                this.$refs.cropper1.rotateRight(); 
            }, 
            // 上传图片（点击上传按钮）
            finish() { 
                
               
                var that = this;
                
                let formData = new FormData();
                // 输出 
                
                this.$refs.cropper1.getCropBlob((data) => { 
                    let img = window.URL.createObjectURL(data) 
                    
                    // 上传data:
                    formData.append('file',data,that.fileName);   
                    formData.append('guid',that.guid);
                    formData.append('type',that.data.type);
                    
                    if( data.size< 2000000){
                       
                        this.$emit('childFun',{
                            pic_url: formData,
                           
                        });
                        that.$alert.info('获取图片成功'); 
            
                    } else {
                        that.$alert.info('图片不得大于2MB'); 
                            
                    } 
                })
                
              
            }, 
        
            // 下载图片
            down(type) { 
                
                var aLink = document.createElement('a') 
                aLink.download = 'author-img' 
                if (type === 'blob') { 
                this.$refs.cropper1.getCropBlob((data) => { 
                    this.downImg = window.URL.createObjectURL(data)
                    aLink.href = window.URL.createObjectURL(data) 
                    aLink.click() 
                }) 
                } else { 
                this.$refs.cropper1.getCropData((data) => { 
                    this.downImg = data;
                    aLink.href = data; 
                    aLink.click() 
                   
                }) 
                } 
            }, 
            // 选择本地图片
            uploadImg(e,num) { 
                
                var that = this;
                // 上传图片
                
                
                var file = e.target.files[0] 
                that.fileName = file.name;
                
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) { 
                    alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种') 
                        return false 
                } 
                
                
                var reader = new FileReader(); 
                reader.onload =(e) => { 
                    let data; 
                    
                    if (typeof e.target.result === 'object') { 
                        // 把Array Buffer转化为blob 如果是base64不需要 
                        data = window.URL.createObjectURL(new Blob([e.target.result])) 
                               
                    }else { 
                        data = e.target.result 
                    }
                    
                    if (num === 1) {  
                        that.option.img = data;
                        that.head_pic = data;
                    
                    } 
               
                } 
                // 转化为base64 
                // reader.readAsDataURL(file) 
                // 转化为blob 
                
                reader.readAsArrayBuffer(file);
            }, 
            imgLoad(msg) { 
                // console.log('imgLoad',msg) 
            },

            //防止cropper报没有realTime的错
           realTime(){

           },
        },
        mounted: function(){
            let that = this;
            that.head_pic = that.$store.state.image;
            that.guid     = that.$store.state.guid;
         
        }
        
    }
</script>
<style scoped>
    .b_txt{
        /* color:#999; */
        background: transparent!important;
        margin-left: 20px;
    }



    /* 切换头像弹窗 */
    .cropper-component { 
        margin-left: 64px;     /** 80(width) - 16 （padding）**/
        width: 260px;
        background: white;
        z-index: 9999;
        
    }
    .cropper-component .btn-box {
        margin: 20px 0;
       
    }
    .cropper-component .btn-box .btn {
        padding: 4px 12px;
        text-align: center;
        border-radius: 4px;
        background-color: #387EF6;
        color: #fff;
        cursor: pointer;
        display: inline-block;
    }
    .cropper-component .btn-box .operation-btn {
        width: 30px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        background-color: #fff;
        border: 1px solid #eaeaea;
        cursor: pointer;
        display: inline-block;
        font-size: 20px;
        color: #333;
        padding: 0;
        margin: 0 10px;
    }
    .cropper-component .info-item .operation-box {
        display: inline-block;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid #39f;
    }
    .cropper-component .info-item .operation-box .cropper {
        
        width: 260px;
        height: 260px;
    }


    /* 剪切头像底部按钮 */
    .bot_btn{
        width: 100%;
        height: 50px;
        display: flex;
        padding: 0 22%;
    }
    .bot_btn div[class^="bb_"]{
        flex:1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        font-weight: 400;
        color: white;
        background: #1abc9c;
        margin: 0 10px;
        margin-top: 10px;
        font-size: 15px;
    }
   
</style>